import { Theme, makeStyles } from "@material-ui/core";

export const useProductionTableStyles = makeStyles((theme: Theme) => ({
	"@global": {
		".ag-row .actions-container": {
			opacity: 0,
			transition: "opacity 0.2s ease-in-out",
			minWidth: "24px",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		".ag-row:hover .actions-container": {
			opacity: 1,
		},
	},
	actionsCell: {
		display: "flex",
		alignItems: "center",
		height: "100%",
	},
}));
